import React, { useState } from "react";
import Icon from "../Utilities/Icon"
import statWinner from "../../js/statWinner"
import statPer90 from "../../js/statPer90"
import gamesPerStat from "../../js/gamesPerStat"
import percentageOf from "../../js/percentageOf"
import validNum from "../../js/validNum"
import {tabs, barWrap, yearLabel, mbar, rbar} from "./ModalSeasonBreakdown.module.css"


const ModalSeasonBreakdown = (props) => {

  const [statView, setStatView] = useState('Totals');
  const manageStatView = (view) => setStatView(view);

  // Is the competition League + UCL ?
  const leagueUCL = props.competition === "League + Champs League" || props.competition === "League/Champs League" || props.competition === "League and Europe Since 10" || props.competition === "All Time Top 5 League and Champions League" ? true : false

  // Set the competition variable to correspond with the competition name used in the data sheets
  const competition =
  props.competition === "Other Club Cups" ? "Other Cups"
  : props.competition === "All Time Club" ? "All Competitions"
  : props.competition === "All Time Career" ? "Club and Country"
  : props.competition === "International" ? "All Internationals"
  : props.competition === "League (Since 14/15)" ? "League"
  : props.competition === "League Since 09" ? "League"
  : props.competition === "League Since 10" ? "League"
  : props.competition === "All Time League Europe" ? "League"
  : props.competition === "Europe Since 09" ? "Champions League"
  : leagueUCL ? "All Competitions"
  : props.competition

  // Get the data rows, filtered by current competition and create new array with appropriate values
  // 'stat' is set to mainStat which is the last value in the query object
  const getData = (data) => {

    let i = 0;

    const minsPlayedLeague = [...data.filter(d => d.node.competition === "League").map(d => d.node.minsPlayed)]
    const minsPlayedUCL = [...data.filter(d => d.node.competition === "Champions League").map(d => d.node.minsPlayed)]

    const mainStat = data.filter(d => d.node.competition === competition).map(d => d.node[Object.keys(d.node)[Object.keys(d.node).length - 1]]);

    return data.filter(d => d.node.competition === competition).map(d => 
      ({
        'year': d.node.year.replace(/-20/g, '/'),
        'apps': Number(d.node.apps),
        'goals': Number(d.node.goals),
        'outsideBox': Number(d.node.outside),
        'assists': Number(d.node.assists),
        'reboundGkAssist': Number(d.node.reboundGkAssist),
        'reboundPostAssist': Number(d.node.reboundPostAssist),
        'deflectedAssist': Number(d.node.deflectedAssist),
        'penWonAssist': Number(d.node.penWonAssist),
        'ownGoalAssist': Number(d.node.ownGoalAssist),
        'pensMissed': Number(d.node.pensMissed),
        'pens': Number(d.node.pens),
        'pointsWon': Number(d.node.pointsWon),
        'subStatPointsWon': Number(d.node.subStatPointsWon),
        'subStatGPointsWon': Number(d.node.subStatGPointsWon),
        'subStatGAPointsWon': Number(d.node.subStatGAPointsWon),
        'gPointsWon': Number(d.node.gPointsWon),
        'gaPointsWon': Number(d.node.gaPointsWon),
        'minsPerGoalCont': Math.round(d.node.minsPerGoalContribution),
        'minsPerGoal': Math.round(d.node.minsPerGoal),
        'shotsPerGoal': Number(d.node.shotsPerGoal).toFixed(2),
        'minsPerStat': leagueUCL ? Number(minsPlayedLeague[i])+Number(minsPlayedUCL[i]) : Number(d.node.minsPlayed) / mainStat,
        'minsPerNonPenGoal': Math.round(d.node.minsPlayed / (d.node.goals - d.node.pens)),
        'freq': gamesPerStat(mainStat[i], d.node.apps),
        'per90': statPer90(mainStat[i], leagueUCL ? Number(minsPlayedLeague[i])+Number(minsPlayedUCL[i]) : Number(d.node.minsPlayed)),
        'percOfGames': Math.round(mainStat[i] * (100 / d.node.apps)),
        'percScored': Math.round(d.node.goals * (100 / mainStat[i])),
        'penCon': Math.round(parseFloat(mainStat[i]) * (100 / (parseFloat(mainStat[i]) + parseFloat(d.node.pensMissed)))),
        'mins': leagueUCL ? Number(minsPlayedLeague[i])+Number(minsPlayedUCL[i]) : Number(d.node.minsPlayed),
        'stat': Number(mainStat[i++])
      })
    )
  }

  // Get the messi data from the appropriate sheet, based on the competition
  let mdata =
  props.mdata ? getData(props.mdata)
  : props.competition === 'All Time Career' ? getData(props.data.allSheetMessiCalYearStats.edges)
  : props.competition === 'International' ? getData(props.data.allSheetMessiIntStats.edges)
  : getData(props.data.allSheetMessiClubStats.edges)

  // Get the ronaldo data from the appropriate sheet, based on the competition
  let rdata =
  props.rdata ? getData(props.rdata)
  : props.competition === 'All Time Career' ? getData(props.data.allSheetRonaldoCalYearStats.edges)
  : props.competition === 'International' ? getData(props.data.allSheetRonaldoIntStats.edges)
  : getData(props.data.allSheetRonaldoClubStats.edges)

  // This line is required due to node support issues for Object.fromEntries
  Object.fe = arr => Object.assign({}, ...Array.from(arr, ([k, v]) => ({[k]: v}) ));

  // Map over the two arrays and prefix all the keys with m or r
  mdata = mdata.map(entry => { return Object.fe( Object.entries(entry).map(([key, value]) => [`m${key}`, value] ) ) })
  rdata = rdata.map(entry => { return Object.fe( Object.entries(entry).map(([key, value]) => [`r${key}`, value] ) ) })

  // Combine the two arrays so we have both players' stats in a single object per year/season
  const bothData = mdata.map((item, key) => Object.assign({}, item, rdata[key]))


  // Adjust the main mstat and rstat values based on the current state
  // mstat and rstat are then used as the values in the actual bar charts
  const finalData =
  props.statType === "Points Won via Goals" && statView === "Totals" ? (
    bothData.map(({ mgPointsWon, rgPointsWon, ...d }) => ({ ...d,
      mstat: mgPointsWon,
      rstat: rgPointsWon
    }))
  ) : props.statType === "Points Won via Goals + Assists" && statView === "Totals" ? (
    bothData.map(({ mgaPointsWon, rgaPointsWon, ...d }) => ({ ...d,
      mstat: mgaPointsWon,
      rstat: rgaPointsWon
    }))
  ) : props.statType === "Points Won" && statView === "Totals" ? (
    bothData.map(({ mpointsWon, rpointsWon, ...d }) => ({ ...d,
      mstat: mpointsWon,
      rstat: rpointsWon
    }))
  ) : props.statType === "Average Match Ratings" ? (
    bothData.map(({ mstat, rstat, ...d }) => ({ ...d,
      mstat: mstat.toFixed(2),
      rstat: rstat.toFixed(2)
    }))
  ) : statView === "Actual Goals vs xG" ? (
    bothData.map(({ mgoals, mstat, rgoals, rstat, ryear, ...d }) => ({ ...d,
      mstat: mstat ? Number(mgoals-mstat).toFixed(2) : '0',
      rstat: rstat ? Number(rgoals-rstat).toFixed(2) : '0'
    }))
  ) : (statView === "Totals" && props.statType === "Goal Contributions") || statView === "Goals & Assists" ? (
    bothData.map(({ massists, mstat, rassists, rstat, ...d }) => ({ ...d,
      mstat: mstat+massists,
      rstat: rstat+rassists
    }))
  ) : (statView === "Totals" && props.statType === "All Assist Types") ? (
    bothData.map(({ massists, rassists, mreboundGkAssist, mreboundPostAssist, mdeflectedAssist, mpenWonAssist, mownGoalAssist, rreboundGkAssist, rreboundPostAssist, rdeflectedAssist, rpenWonAssist, rownGoalAssist, ...d }) => ({ ...d,
      mstat: massists+mreboundGkAssist+mreboundPostAssist+mdeflectedAssist+mpenWonAssist+mownGoalAssist,
      rstat: rassists+rreboundGkAssist+rreboundPostAssist+rdeflectedAssist+rpenWonAssist+rownGoalAssist
    }))
  ) : (statView === "Opta Assists" && props.statType === "All Assist Types") ? (
    bothData.map(({ massists, rassists, ...d }) => ({ ...d,
      mstat: massists,
      rstat: rassists
    }))
  ) : (statView === "Deflected Assists" && props.statType === "All Assist Types") ? (
    bothData.map(({ mdeflectedAssist, rdeflectedAssist, ...d }) => ({ ...d,
      mstat: mdeflectedAssist,
      rstat: rdeflectedAssist
    }))
  ) : (statView === "GK Rebounds" && props.statType === "All Assist Types") ? (
    bothData.map(({ mreboundGkAssist, rreboundGkAssist, ...d }) => ({ ...d,
      mstat: mreboundGkAssist,
      rstat: rreboundGkAssist
    }))
  ) : (statView === "Post Rebounds" && props.statType === "All Assist Types") ? (
    bothData.map(({ mreboundPostAssist, rreboundPostAssist, ...d }) => ({ ...d,
      mstat: mreboundPostAssist,
      rstat: rreboundPostAssist
    }))
  ) : (statView === "Own Goal Assists" && props.statType === "All Assist Types") ? (
    bothData.map(({ mownGoalAssist, rownGoalAssist, ...d }) => ({ ...d,
      mstat: mownGoalAssist,
      rstat: rownGoalAssist
    }))
  ) : (statView === "Pens Won" && props.statType === "All Assist Types") ? (
    bothData.map(({ mpenWonAssist, rpenWonAssist, ...d }) => ({ ...d,
      mstat: mpenWonAssist,
      rstat: rpenWonAssist
    }))
  ) : (statView === "Totals" && props.statType === "Goals Without Penalties") ? (
    bothData.map(({ mpens, mstat, rpens, rstat, ...d }) => ({ ...d,
      mstat: mstat-mpens,
      rstat: rstat-rpens
    }))
  ) : statView === "Totals" || statView === "Goals" || statView === "Goals Only" ? (
    bothData
  ) : statView === "Per 90 mins" ? (
    bothData.map(({ mper90, rper90, ...d }) => ({ ...d,
      mstat: validNum(mper90) ? mper90 : -'',
      rstat: validNum(rper90) ? rper90 : -''
    }))
  ) : statView === "Assists Only" || statView === "Actual Assists" ? (
    bothData.map(({ massists, rassists, ryear, ...d }) => ({ ...d,
      mstat: massists,
      rstat: rassists
    }))
  ) : statView === "Shots Per Goal" ? (
    bothData.map(({ mshotsPerGoal, rshotsPerGoal, ...d }) => ({ ...d,
      mstat: Number(mshotsPerGoal),
      rstat: Number(rshotsPerGoal)
    }))
  ) : statView === "Mins Per Goal/Assist" ? (
    bothData.map(({ mminsPerGoalCont, rminsPerGoalCont, ...d }) => ({ ...d,
      mstat: mminsPerGoalCont,
      rstat: rminsPerGoalCont
    }))
  ) : statView === "Mins Per Goal" ? (
    bothData.map(({ mminsPerGoal, rminsPerGoal, ...d }) => ({ ...d,
      mstat: mminsPerGoal,
      rstat: rminsPerGoal
    }))
  ) : statView === "Mins Per Non-penalty Goal" ? (
    bothData.map(({ mminsPerNonPenGoal, rminsPerNonPenGoal, ...d }) => ({ ...d,
      mstat: validNum(mminsPerNonPenGoal) ? mminsPerNonPenGoal : '-',
      rstat: validNum(rminsPerNonPenGoal) ? rminsPerNonPenGoal : '-'
    }))
  ) : statView === "Frequency" ? (
    bothData.map(({ mfreq, rfreq, ...d }) => ({ ...d,
      mstat: validNum(mfreq) ? Number(mfreq) : '-',
      rstat: validNum(rfreq) ? Number(rfreq) : '-'
    }))
  ) : statView === "Penalty Conversion %" ? (
    bothData.map(({ mpenCon, rpenCon, ...d }) => ({ ...d,
      mstat: validNum(mpenCon) ? mpenCon : '-',
      rstat: validNum(rpenCon) ? rpenCon : '-'
    }))
  ) : statView === 'Pens as % of Total Goals' ? (
    bothData.map(({ mpens, mgoals, rpens, rgoals, ...d }) => ({ ...d,
      mstat: validNum(percentageOf(mpens, mgoals, 1)) ? Number(percentageOf(mpens, mgoals, 0)) : '-',
      rstat: validNum(percentageOf(rpens, rgoals, 1)) ? Number(percentageOf(rpens, rgoals, 0)) : '-',
      mpens: validNum(mpens) ? mpens : '-',
      rpens: validNum(rpens) ? rpens : '-',
      mgoals: validNum(mgoals) ? mgoals : '-',
      rgoals: validNum(rgoals) ? rgoals : '-'
    }))
  ) : statView === "% of Games" ? (
    bothData.map(({ mpercOfGames, rpercOfGames, ...d }) => ({ ...d,
      mstat: validNum(mpercOfGames) ? mpercOfGames : '-',
      rstat: validNum(rpercOfGames) ? rpercOfGames : '-'
    }))
  ) : statView === "% Scored" ? (
    bothData.map(({ mpercScored, rpercScored, ...d }) => ({ ...d,
      mstat: validNum(mpercScored) ? mpercScored : '-',
      rstat: validNum(rpercScored) ? rpercScored : '-'
    }))
  ) : statView === "% of Contested Points" ? (
    bothData.map(({ msubStatPointsWon, rsubStatPointsWon, ...d }) => ({ ...d,
      mstat: msubStatPointsWon,
      rstat: rsubStatPointsWon
    }))
  ) : props.statType === "Points Won via Goals" && statView === "% of Team's Points" ? (
    bothData.map(({ msubStatGPointsWon, rsubStatGPointsWon, ...d }) => ({ ...d,
      mstat: msubStatGPointsWon,
      rstat: rsubStatGPointsWon
    }))
  ) : props.statType === "Points Won via Goals + Assists" && statView === "% of Team's Points" ? (
    bothData.map(({ msubStatGAPointsWon, rsubStatGAPointsWon, ...d }) => ({ ...d,
      mstat: msubStatGAPointsWon,
      rstat: rsubStatGAPointsWon
    }))
  ) : ''



  // Find the highest mstat value and the highest rstat value in the finalData array
  // If the current stat view is % based then we'll just use 100% as the ceiling for the bar charts
  let mHighest = Math.max.apply(Math, finalData.filter(d => d.mstat !== '-').map(d => d.mstat))

  let mBarCeiling = 
    statView.includes('Mins Per') && mHighest >= 190 ? '190'
    : statView.includes('Frequency') && mHighest >= 40 ? '40'
    : mHighest

  let rHighest = Math.max.apply(Math, finalData.filter(d => d.rstat !== '-').map(d => d.rstat))
  
  let rBarCeiling = 
    statView.includes('Mins Per') && rHighest >= 190 ? '190'
    : statView.includes('Frequency') && rHighest >= 40 ? '40'
    : rHighest
  
  // Find the highest out of top mstat value and top rstat value - this is the ceiling for all the bar charts
  const statW = statWinner(mBarCeiling, rBarCeiling)

  // Define whether the lower number is better or the higher number is better in the current stat view
  let highLow = statView === "Frequency" || statView === "Shots Per Goal" || statView === "Mins Per Goal" || statView === "Mins Per Goal/Assist" || statView === "Mins Per Non-penalty Goal" || statView === "Pens as % of Total Goals" ? 'lowWins' : 'highWins'

  return (
    <div className={`w-full max-w-2xl mx-auto px-4`}>
      
      {props.statView.length > 1 ? (
        <ul className={`${tabs} mb-4 flex overflow-x-scroll scroll-smooth md:overflow-x-visible`}>
          {props.statView.map(view => (
            <li
              key={view}
            >
              <button
                className={`text-sm flex-none mx-1 px-4 py-2 rounded-full cursor-pointer transition-300 ${view === statView ? 'bg-highlight hover:bg-highlight-lighten10 focus:bg-highlight' : 'bg-slate-200 hover:bg-slate-300 focus:bg-slate-300'}`}
                onClick={() => manageStatView(view)}
              >
                {view === "Frequency" && props.statType === "Free Kicks" ? 'Games Per Free Kick Goal'
                : view === "Frequency" && props.statType === "Hat Tricks" ? 'Games Per Hat Trick'
                : view === "Frequency" && props.statType === "Outside the box goals (open play)" ? 'Games Per Outside Box Goal'
                : view === "Frequency" && props.statType === "Assists (Opta)" ? 'Games Per Assist'
                : view === "Totals" && props.statType === "All Assist Types" ? 'All'
                : view}
              </button>
            </li>
          ))}
        </ul>
      ) : ''}

      { finalData.map(d => (

        props.since === "09/10" && (d.ryear === "2008/09" || d.ryear === "2007/08" || d.ryear === "2006/07" || d.ryear === "2005/06" || d.ryear === "2004/05" || d.ryear === "2003/04") ? '' : (

        d.rstat !== null ? (

        <div key={d.myear} className={`${barWrap} flex w-full mb-2`}>

          <div className={`w-1/2 flex flex-wrap justify-end relative`}>
            <p className={`${yearLabel}`}><span className="sr-only">Messi {props.competition} {props.statType}</span> {d.myear}</p>
            <div className={`${mbar} rounded relative flex justify-end items-center bg-slate-200 lg:bg-slate-200 #a1d8da overflow-hidden`}>
              <div
                className={`rounded flex items-center justify-end absolute top-0 bottom-0 right-0 z-10 transition-300 ${statView === "FrequencyDIS" ? 'opacity-15' : ''} bg-messi`}
                style={{width: d.mstat < '0.001' ? 0 : statW === 'm' ? ((d.mstat/mBarCeiling)*100)+'%' : ((d.mstat/rBarCeiling)*100)+'%'}}>
              </div>

              {statWinner(d.mstat, d.rstat, highLow) === "m" && d.mstat !== '0' ? <Icon iconName="icon-star" class="relative z-20 inline-block text-highlight mr-2" /> : ''}

              <span className={`relative z-20 whitespace-nowrap font-bold text-right pr-1 md:pr-3 text-white ${(d.mstat < '0.001' || d.mstat === '-') ? 'text-messi' : ''} ${statView === "FrequencyDIS" ? 'text-messi-darken10' : ''}`}>
                {statView === "FrequencyDIS" && d.mstat !== '0' ? (
                  <span className='font-normal text-sm'><strong className="text-base">{d.mstat}</strong> games</span>
                ) : (
                  <span>{d.mstat}{statView.includes('%') ? '%' : ''}</span>
                )}
                {props.statType === "Penalties" && statView === "Totals" ?
                  <span className="text-xs opacity-75 font-light">/{parseFloat(d.mpensMissed)+parseFloat(d.mstat)}</span>
                : statView === "Pens as % of Total Goals" ?
                  <span className="text-xs opacity-75 font-light"> ({d.mpens}/{d.mgoals})</span>
                : statView === "Actual Goals vs xG" ?
                <span className="text-xs opacity-75 font-light"> &gt; xG</span>
                : ''}
              </span>

            </div>
          </div>


          <div className={`w-1/2 relative`}>
            <p className='sr-only'>Ronaldo {props.competition} {props.statType} {d.ryear}</p>
            <div className={`${rbar} rounded relative flex items-center bg-slate-200 lg:bg-slate-200 #efc5d5 overflow-hidden`}>
              <div
                className={`rounded flex items-center justify-end absolute top-0 bottom-0 left-0 z-10 transition-300 ${statView === "FrequencyDIS" ? 'opacity-10' : ''} bg-ronaldo`}
                style={{width: d.rstat < '0.001' ? 0 : statW === 'r' ? ((d.rstat/rBarCeiling)*100)+'%' : ((d.rstat/mBarCeiling)*100)+'%'}}>
              </div>

              {statWinner(d.mstat, d.rstat, highLow) === "r" && d.rstat !== '0' ? <Icon iconName="icon-star" class="relative z-20 inline-block text-highlight ml-2 order-1" /> : ''}

              <span className={`relative z-20 whitespace-nowrap font-bold text-left pl-1 md:pl-3 text-white ${(d.rstat < '0.001' || d.rstat === '-') ? 'text-ronaldo' : ''} ${statView === "FrequencyDIS" ? 'text-ronaldo-darken10' : ''}`}>

                {statView === "FrequencyDIS" && d.rstat !== '0' ? (
                  <span className='font-normal text-sm'><strong className="text-base">{d.rstat}</strong> games</span>
                ) : statView === "Actual Goals vs xG" && d.ryear === '2022/23' ? (
                  <span>-1.08</span>
                ) : (
                  <span>{d.rstat}{statView.includes('%') ? '%' : ''}</span>
                )}

                {props.statType === "Penalties" && statView === "Totals" ?
                  <span className="text-xs opacity-75 font-light">/{parseFloat(d.rpensMissed)+parseFloat(d.rstat)}</span>
                : statView === "Pens as % of Total Goals" ?
                  <span className="text-xs opacity-75 font-light"> ({d.rpens}/{d.rgoals})</span>
                : statView === "Actual Goals vs xG" ?
                  <span className="text-xs opacity-75 font-light"> &gt; xG</span>
                : '' }
              </span>

            </div>
          </div>

        </div>

        ) : ''
        )
      ))}

    </div>
  )
}

ModalSeasonBreakdown.defaultProps = {
  since: 'all',
  statView: []
};

export default ModalSeasonBreakdown